export default "__VITE_ASSET__CLfj855a__"